const TENANT_MAPPING = {
    "buggy": ["Orlando_FL_", "Boston_MA", "FHV_Las_Vegas_NV_", "Washington_DC", "TAMPA_FL", "BROOKLYN_NY", "MIAMI_FL", "Atlanta_GA", "Philadelphia_PA", "Milwaukee_WI"],
    "ucars": ["Austin_TX", "HOUSTON_TX", "UCars_Dallas_TX", "UCars_Phoenix_AZ"],
    "ft": ["FASTTRACK_BROOKLYN"],
    "mnave": ["CDMX_MX", "GDL_MX", "PU_MX", "TOL_MX"],
}

const getBaseURL = () => {
    let branch = window.location.hash.replace('#', '')
    let tenant = Object.keys(TENANT_MAPPING).find(tenantKey => TENANT_MAPPING[tenantKey].includes(branch)) || "buggy"

    return window.location.hostname.includes("staging") || window.location.hostname === "localhost" ? `https://staging.${process.env.REACT_APP_BUGGY_BASE_URL}` : `https://${tenant}.${process.env.REACT_APP_BUGGY_BASE_URL}`
}

const toTitleCase = (text) => {
    if (text) {
        text = String(text).toLowerCase()
        // text = text.split(' ')
        text = text.split(/[_ -]+/)

        if (Array.isArray(text)) {
            for (var i = 0; i < text.length; i++)
                text[i] = text[i].charAt(0).toUpperCase() + text[i].slice(1)
            return text.join(' ')
        } else {
            return text.charAt(0).toUpperCase() + text.slice(1)
        }
    }
    return ""
}
export { getBaseURL, toTitleCase }